import { useState, useEffect, useMemo } from "react";
import React from "react";
import { InputFieldKYC, } from "../BusinessFlow/Kycform";
import { useNavigationType } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { COUNTRIES, SOURCE_OF_INCOME } from "../Constant";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css"; // or any theme
import { COMPLIANCE_REJECTED } from "../utilities";
import Cookies from 'js-cookie';



const InvestorContactDetails = ({ indivInvFormData,
    investorDatauser, handleFieldChange, onNext, validateErrors, setValidateErrors, removeCompletedStep, handleSaveKYCDraft }) => {

    const [showIntro, setShowIntro] = useState(false);



    const navigationType111 =
        performance.getEntriesByType("navigation")[0]?.type;
    const navigationType = useNavigationType();
    const cameFromPersonal = sessionStorage.getItem("fromPersonal");

    useEffect(() => {


        if (navigationType111 === "reload" && cameFromPersonal) {
            setShowIntro(false);
        } else if (navigationType111 === "reload" && !cameFromPersonal) {
            setShowIntro(true);
        } else if (navigationType111 === "navigate" && !cameFromPersonal) {
            setShowIntro(true);
        }
        else {
            setShowIntro(false);
        }

        // Clear the flag immediately after
        sessionStorage.removeItem("fromPersonal");
    }, [navigationType]);



    const validateMandatoryFields = () => {
        const newErrors = {};

        const investor_name =
            indivInvFormData?.investor_name;

        const phone =
            indivInvFormData?.phone;

        const country =
            indivInvFormData?.country;

        const country_of_residence =
            indivInvFormData?.country_of_residence;

        const nationality =
            indivInvFormData?.nationality;

        const date_of_birth =
            indivInvFormData?.date_of_birth;

        const name_of_employer =
            indivInvFormData?.name_of_employer;

        const sourse_of_fund =
            indivInvFormData?.sourse_of_fund;

        const committed_principal =
            indivInvFormData?.committed_principal;

        const gender =
            indivInvFormData?.gender;

        const investor_company_name =
            indivInvFormData?.investor_company_name;



        if (!investor_name) newErrors.investor_name = true;

        if (!phone)
            newErrors.phone = true;

        if (!country) newErrors.country = true;
        if (!country_of_residence) newErrors.country_of_residence = true;
        if (!nationality) newErrors.nationality = true;
        if (!date_of_birth) newErrors.date_of_birth = true;

        if (!gender) newErrors.gender = true;
        if (!investor_company_name) newErrors.investor_company_name = true;

        if (!name_of_employer || name_of_employer.trim().length === 0) {
            newErrors.name_of_employer = true;
        }
        if (!sourse_of_fund) newErrors.sourse_of_fund = true;
        if (!committed_principal) newErrors.committed_principal = true;


        setValidateErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };




    const handlePhoneChange = (e) => {
        let value = e.target.value;

        // Allow only digits and +
        if (!/^[0-9+]*$/.test(value)) return;

        // Only one +
        if ((value.match(/\+/g) || []).length > 1) return;

        // + must be at the start
        if (value.includes("+") && value[0] !== "+") return;

        // limit max length
        if (value.length > 15) return;

        handleFieldChange("phone", value);
    };




    const formatDOB = (value) => {
        if (!value) return "";

        let d;

        // Case 1: YYYY-MM-DD (no timezone issues)
        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
            const [year, month, day] = value.split("-");
            return `${day}-${month}-${year}`;
        }

        // Case 2 & 3: timestamp number or numeric string
        const timestamp = Number(value);
        if (!isNaN(timestamp)) {
            d = new Date(timestamp);
        } else {
            d = new Date(value);
        }

        if (isNaN(d.getTime())) return "";

        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}-${month}-${year}`;
    };

    const dobValue = formatDOB(indivInvFormData?.date_of_birth);


    const today = new Date();
    const min18Date = new Date(
        today.getFullYear() - 18,
        today.getMonth(),
        today.getDate()
    );

    const reason = investorDatauser?.kyc?.[0]?.admin_notes;

    const truncateWords = (text, limit = 35) => {
        if (!text) return "";

        if (text.length <= limit) return text;

        return text.substring(0, limit) + "...";
    };

    const renderKycStatus = () => {
        if (!investorDatauser?.kyc) return null;


        // if (reason) {
        if (investorDatauser?.kyc?.[0]?.status === COMPLIANCE_REJECTED) {
            return (
                <div className="kyc-status kyc-status-rejected">
                    <div>Status: Rejected</div>

                    <div className="kyc-reason">
                        Reason:
                        <span title={reason}
                            style={{ fontSize: "15px" }}>
                            {truncateWords(reason, 35)}
                        </span>
                    </div>
                </div>
            );
        }


        return null;
    };





    return (
        <div className="kyc-poppins-ui">
            <>
                {showIntro && (

                    <Modal
                        show={showIntro}
                        onHide={() => setShowIntro(false)}
                        centered
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Body className="text-center p-4 kyc-poppins-ui">


                            <div className="modal-icon">
                                <svg width="32" height="32" fill="#f59e0b" viewBox="0 0 24 24">
                                    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"></path>
                                </svg>
                            </div>

                            <h4 className="fw-bold mb-2">Keep These Documents Ready</h4>

                            <p className="text-muted">
                                Before you begin, please ensure you have the following documents prepared for a smooth verification process:
                            </p>

                            {/* CHECKLIST */}
                            <div className="document-checklist text-start my-3">
                                <div className="checklist-item d-flex align-items-start mb-2">
                                    <div className="checklist-icon me-2">
                                        <svg width="16" height="16" fill="white" viewBox="0 0 24 24">
                                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"></path>
                                        </svg>
                                    </div>
                                    <div>
                                        <strong>2 Government-issued IDs</strong> (National ID, Passport, or Driving License)
                                    </div>
                                </div>

                                <div className="checklist-item d-flex align-items-start mb-2">
                                    <div className="checklist-icon me-2">
                                        <svg width="16" height="16" fill="white" viewBox="0 0 24 24">
                                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"></path>
                                        </svg>
                                    </div>
                                    <div>
                                        <strong>3 Months Bank Statement</strong> (PDF format, recent statements from your bank)
                                    </div>
                                </div>

                                <div className="checklist-item d-flex align-items-start">
                                    <div className="checklist-icon me-2">
                                        <svg width="16" height="16" fill="white" viewBox="0 0 24 24">
                                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"></path>
                                        </svg>
                                    </div>
                                    <div>
                                        <strong>Access to Camera</strong> (For selfie verification)
                                    </div>
                                </div>
                            </div>

                            {/* ACTION BUTTON */}
                            <Button

                                className="w-100 fw-semibold mt-3 kyc-modal-primary-btn"
                                onClick={() => setShowIntro(false)}
                            >
                                I&apos;m Ready, Let&apos;s Start →
                            </Button>

                        </Modal.Body>
                    </Modal>

                )}

                <div className="main-content">
                    <div className="content-wrapper">

                        <div className="review-header-row">

                            <div className="step-header">
                                <div className="step-title">Personal Details</div>
                                <div className="step-subtitle">
                                    Hello <strong>{investorDatauser?.investor_name}</strong>, let's get started with your personal details.
                                </div>
                            </div>
                            <div className="review-status">
                                {renderKycStatus()}
                            </div>

                        </div>



                        <div className="row gap-lg-3">
                            <InputFieldKYC
                                divClass="col-lg-12"
                                mandatory={"*"}
                                id="investor_name"
                                name="investor_name"
                                htmlFor="investor_name"
                                label={"Full Name of the Investor (as per ID Proof)"}
                                placeholder={'Investor Name'}
                                onChange={(e) => handleFieldChange('investor_name', e.target.value)}
                                value={indivInvFormData?.investor_name}

                                error={validateErrors.investor_name}
                            />
                        </div>


                        <div className="row allow-gutter gy-3">


                            <div className="col-lg-6">
                                <InputFieldKYC
                                    type="tel"
                                    mandatory="*"
                                    id="phone"
                                    name="phone"
                                    htmlFor="phone"
                                    label="Mobile Number"
                                    placeholder="Mobile Number"
                                    onChange={handlePhoneChange}
                                    value={indivInvFormData?.phone || ""}
                                    error={validateErrors.phone}
                                />


                                {typeof validateErrors.phone === "string" && (
                                    <div className="text-danger small mt-1">
                                        {validateErrors.phone}
                                    </div>
                                )}
                            </div>



                            <InputFieldKYC
                                divClass="col-lg-6"
                                label={"Email"}
                                id="email"
                                name="email"
                                htmlFor={"email"}
                                mandatory={"*"}
                                placeholder={"Email"}
                                readOnly={true}
                                value={investorDatauser?.email || ""}
                                disabled={true}
                            />




                        </div>


                        <div className="row allow-gutter gy-3">

                            <div className="col-lg-6 settings_YOE">
                                <label className="nomine-relation-label"
                                >
                                    Date of Birth
                                    <span className="required">*</span>
                                </label>
                                <Flatpickr
                                    options={{
                                        dateFormat: "d-m-Y",     // DD-MM-YYYY
                                        maxDate: "today",        // disable future dates
                                        allowInput: false,        // allow typing
                                        monthSelectorType: "dropdown", // easier DOB selection
                                        yearSelectorType: "dropdown",
                                    }}


                                    onChange={([date]) => {
                                        handleFieldChange(
                                            "date_of_birth",
                                            date
                                                ? Date.UTC(
                                                    date.getFullYear(),
                                                    date.getMonth(),
                                                    date.getDate()
                                                )
                                                : null
                                        );
                                    }}

                                    value={dobValue}
                                    className={`form-control bg-white ${validateErrors.date_of_birth ? "input-error" : ""
                                        }`}

                                    placeholder="dd-mm-yyyy"

                                />

                            </div>

                            <div className="col-lg-6">
                                <label className="nomine-relation-label">
                                    Nationality <span className="required">*</span>
                                </label>

                                <select
                                    className={`form-select ${validateErrors.nationality ? "input-error" : ""}`}
                                    value={indivInvFormData?.nationality}
                                    onChange={(e) => handleFieldChange("nationality", e.target.value)}
                                >
                                    <option value="">Select country</option>
                                    {COUNTRIES.map((country) => (
                                        <option key={country} value={country}>
                                            {country}
                                        </option>
                                    ))}
                                </select>
                            </div>

                        </div>

                        <div className="row allow-gutter gy-3">


                            <div className="col-lg-6">
                                <label htmlFor="nominee_relationship" className="nomine-relation-label">
                                    Gender <span className="required">*</span>
                                </label>

                                <select
                                    className={`form-select ${validateErrors.gender ? "input-error" : ""}`}

                                    aria-label="Gender"
                                    id="gender"
                                    name="gender"
                                    value={
                                        indivInvFormData?.gender
                                    }
                                    onChange={(e) =>
                                        handleFieldChange("gender", e.target.value)
                                    }
                                >
                                    <option value="">Select</option>

                                    {["Male", "Female", "Other"].map(
                                        (gender) => (
                                            <option key={gender} value={gender}>
                                                {gender}
                                            </option>
                                        )
                                    )}
                                </select>
                            </div>



                            <InputFieldKYC label={"Investor Company Name"}
                                divClass="col-lg-6"

                                placeholder={"Investor Company Name"}
                                mandatory={"*"}
                                name={"investor_company_name"}
                                id={"investor_company_name"}
                                error={validateErrors.investor_company_name}
                                onChange={(e) => handleFieldChange('investor_company_name', e.target.value)}
                                value={indivInvFormData?.investor_company_name}
                                onKeyDown={(e) => {
                                    const value = e.target.value;

                                    //  Block space as first character
                                    if (e.key === " " && value.length === 0) {
                                        e.preventDefault();
                                    }
                                }}

                            />

                        </div>

                        <div className="row allow-gutter gy-3">


                            <div className="col-lg-6">
                                <label className="nomine-relation-label">
                                    Country of Birth<span className="required">*</span>

                                </label>

                                <select
                                    className={`form-select ${validateErrors.country ? "input-error" : ""}`}
                                    value={indivInvFormData?.country}
                                    onChange={(e) => handleFieldChange("country", e.target.value)}
                                >
                                    <option value="">Select country</option>
                                    {COUNTRIES.map((country) => (
                                        <option key={country} value={country}>
                                            {country}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-lg-6">
                                <label className="nomine-relation-label">
                                    Country of Residence<span className="required">*</span>
                                </label>

                                <select
                                    className={`form-select ${validateErrors.country_of_residence ? "input-error" : ""}`}
                                    value={indivInvFormData?.country_of_residence}
                                    onChange={(e) => handleFieldChange("country_of_residence", e.target.value)}
                                >
                                    <option value="">Select country</option>
                                    {COUNTRIES.map((country) => (
                                        <option key={country} value={country}>
                                            {country}
                                        </option>
                                    ))}
                                </select>
                            </div>



                        </div>

                        <div className="row allow-gutter gy-3">
                            <InputFieldKYC label={"Name of Employer/Business"}
                                divClass="col-lg-6"

                                placeholder={"Name of Employer/Business"}
                                mandatory={"*"}
                                name={"name_of_employer"}
                                id={"name_of_employer"}
                                error={validateErrors.name_of_employer}
                                onChange={(e) => handleFieldChange('name_of_employer', e.target.value)}
                                value={indivInvFormData?.name_of_employer}
                                onKeyDown={(e) => {
                                    const value = e.target.value;

                                    //  Block space as first character
                                    if (e.key === " " && value.length === 0) {
                                        e.preventDefault();
                                    }
                                }}

                            />

                            <div className="col-lg-6">
                                <label className="nomine-relation-label">
                                    Source of Income / Source of Funds<span className="required">*</span>
                                </label>

                                <select
                                    className={`form-select ${validateErrors.sourse_of_fund ? "input-error" : ""}`}
                                    value={indivInvFormData?.sourse_of_fund}
                                    onChange={(e) => handleFieldChange("sourse_of_fund", e.target.value)}
                                >
                                    <option value="">Select source</option>
                                    {SOURCE_OF_INCOME.map((source) => (
                                        <option key={source} value={source}>
                                            {source}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="row allow-gutter gy-3">


                            <InputFieldKYC
                                divClass="col-lg-6"
                                label="Annual Income in USD"
                                mandatory="*"
                                type="number"

                                name="committed_principal"
                                id="committed_principal"
                                error={validateErrors.committed_principal}
                                placeholder="Annual Income in USD"


                                onKeyDown={(e) => {
                                    //  Block minus, plus, exponential notation
                                    if (["-", "+", "e", "E"].includes(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    //  Block negative sign
                                    if (value.includes("-")) return;

                                    //  Block 0 or numbers starting with 0
                                    if (value === "0" || /^0\d+/.test(value)) return;

                                    handleFieldChange("committed_principal", value);
                                }}
                                value={
                                    indivInvFormData?.committed_principal
                                }
                            />
                        </div>



                        <div className="button-group">
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    const isValid = validateMandatoryFields();

                                    if (!isValid) {
                                        removeCompletedStep(1); //  Contact Info invalid → remove tick
                                        return; //  stop navigation
                                    }

                                    // ✅ valid → proceed
                                    sessionStorage.setItem("fromPersonal", "true");
                                    handleSaveKYCDraft()
                                    Cookies.remove("kyc_currentPage");

                                    onNext(); // goToNextStep(2)
                                }}
                            >
                                Get Started →
                            </button>



                        </div>
                    </div>
                </div >


            </>
        </div>
    );
};

export default InvestorContactDetails;
